import { FeatureName, ScriptStatus } from '../types/featureFlags';

// Action Types
export enum EScriptStatusTypes {
    SET_SCRIPT_STATUS = 'SET_SCRIPT_STATUS',
    RESET_SCRIPT_STATUS = 'RESET_SCRIPT_STATUS',
    CLEAR_ALL_SCRIPT_STATUS = 'CLEAR_ALL_SCRIPT_STATUS',
}

// Action Creators
export const setScriptStatus = (feature: FeatureName, status: ScriptStatus) => ({
    type: EScriptStatusTypes.SET_SCRIPT_STATUS,
    payload: { feature, status },
});

export const resetScriptStatus = (feature: FeatureName) => ({
    type: EScriptStatusTypes.RESET_SCRIPT_STATUS,
    payload: feature,
});

export const clearAllScriptStatus = () => ({
    type: EScriptStatusTypes.CLEAR_ALL_SCRIPT_STATUS,
});

// State Interface
interface ScriptStatusState {
    [key: string]: ScriptStatus;
}

const initialState: ScriptStatusState = {};

// Reducer
const scriptStatusReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case EScriptStatusTypes.SET_SCRIPT_STATUS:
            return {
                ...state,
                [payload.feature]: payload.status,
            };
        case EScriptStatusTypes.RESET_SCRIPT_STATUS:
            const newState = { ...state };
            delete newState[payload];
            return newState;
        case EScriptStatusTypes.CLEAR_ALL_SCRIPT_STATUS:
            return initialState;
        default:
            return state;
    }
};

export default scriptStatusReducer;
